import { useAuthenticator } from '@aws-amplify/ui-react';

export default function({loggedOutMessage}) {
  const { user, signOut } = useAuthenticator((context) => [context.user]);
  const display = user ? (user.attributes.name || user.attributes.email) : null;
  return user ? <p>Logged in as {display}. <a href="#" onClick={() => signOut()}>Log out</a></p> : <a href="/auth">{loggedOutMessage}</a>
}